import React from 'react'
import { Link } from 'react-router-dom'

import logoLight from '../assets/images/fulllogo.png'
import { about, footerLinks, footerSocial, landing, location, serviceStages } from '../data'

export default function Footer() {
  return (
    <>
       <footer className="footer bg-footer">
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-12 mb-0 mb-md-4 pb-0 pb-md-2">
                        <Link className="logo-footer text-light" to="#"><img src={logoLight} height="75" alt=""/></Link>
                        <p className="mt-4">Helping global companies evaluate, launch and grow in India.</p>
                    </div>

                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="text-light footer-head">Services Quick Links</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {serviceStages.map((item,index)=>{
                                return(
                                    <li key={index}><Link to={item.pagelink} className="text-foot"><i className="mdi mdi-chevron-right me-1"></i> {item.title}</Link></li>
                                )
                            })}
                        </ul>
                    </div>

                    <div className="col-lg-2 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="text-light footer-head">About</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {footerLinks.map((item,index)=>{
                                return(
                                    <li key={index}><Link to={item.pagelink} className="text-foot"><i className="mdi mdi-chevron-right me-1"></i> {item.title}</Link></li>
                                )
                            })}
                        </ul>
                    </div>

                    <div className="col-lg-3 col-md-4 col-12 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <h4 className="text-light footer-head">Locations</h4>
                        <ul className="list-unstyled footer-list mt-4">
                            {location.map((item,index)=>{
                                return(
                                    <li key={index}><i className="mdi mdi-chevron-right me-1"></i> {item}</li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
        <footer className="footer bg-footer footer-bar">
            <div className="container text-center">
                <div className="row align-items-center">
                    <div className="col-sm-6">
                        <div className="text-sm-start">
                            <p className="mb-0">© {new Date().getFullYear()} <span className="text-reset">Pioneer One Global (a Minmini initiative.) All rights reserved</span>.</p>
                        </div>
                    </div>

                    <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                        <ul className="list-unstyled text-sm-end social-icon social mb-0">
                            {footerSocial.map((item,index)=>{
                                let Icon = item.icon
                                return(
                                    <li className="list-inline-item m-x-2" key={index}><Link to={item.link} target="_blank" className="rounded"><i className=" align-middle"><Icon/></i></Link></li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    </>
  )
}
